var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var LocalXHandleModel = require("./localXRotationModel.js");
var LocalXHandleView = require("./localXRotationView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var LocalXRotationController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};

lib_core.inherit(LocalXRotationController, lib_core.Controller);
LocalXRotationController.inject = {
    editor3d : Editor3d
};

module.exports = LocalXRotationController;

LocalXRotationController.prototype.handleId = "rotationLocalX";

LocalXRotationController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new LocalXHandleModel(editor3dModel, this.handleId, this.configuration);
};


LocalXRotationController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new LocalXHandleView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



